import * as React from 'react'
import { Box, Link, Typography } from '@mui/material'
import useStyles from './styles'
import { withTranslation } from 'react-i18next'

function AdminFooter(props) {
  const { t } = props
  const classes = useStyles()

  return (
    <Box className={classes.footer}>
      <Typography className={classes.text}>
        © {new Date().getFullYear()} {t('EnategaMultivendor')}
      </Typography>
      <Box className={classes.links}>
        <Link
          className={classes.link}
          href="https://borku.co.uk"
          target="_blank"
          underline="none">
          {t('EnategaMultivendor')}
        </Link>
        <Link
          className={classes.link}
          href="https://borku.co.uk/#/AboutUs"
          target="_blank"
          underline="none">
          {t('About Us')}
        </Link>
        <Link
          className={classes.link}
          href="https://borku.co.uk"
          target="_blank"
          underline="none">
          {t('Blog')}
        </Link>
      </Box>
    </Box>
  )
}

export default withTranslation()(AdminFooter)
